<template>
    <div class="messages-wrapper">
        <transition-group name="list" mode="in-out" tag="article">
            <article
                class="message"
                v-for="(notification, id) in notifications"
                v-bind:key="`message-${id}`"
                :class="`is-${notification.type}`"
                @click="removeNotification(notification)"
            >
                <div class="message-header">
                    <p>{{ notification.title }}</p>
                    <button
                        class="delete"
                        aria-label="delete"
                        @click="removeNotification(notification)"
                    ></button>
                </div>
                <div class="message-body">
                    {{ notification.content }}
                </div>
            </article>
        </transition-group>
    </div>
</template>

<script>
export default {
    computed: {
        notifications() {
            return this.$store.getters.getNotifications
        }
    },
    methods: {
        removeNotification(notification) {
            this.$store.dispatch('removeNotification', notification)
        }
    }
}
</script>

<style lang="sass" scoped>
.messages-wrapper
    position: fixed
    left: 1.5rem
    top: 1.5rem
    width: calc( 100% - 3rem )
    z-index: 100
</style>
